import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ButtonGroup } from '@mui/material'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'
import SidebarAction from '/components/sidebar-action'

import NotifySelectedDialog from './notify-selected-dialog'
import NotifyAllDialog from '/components/templates/notify-all-dialog'

const NotifyPassesMenu = ({ template, selectedPass, selectedPasses }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [notifySelectedOpen, setNotifySelectedOpen] = useState(false)
  const [notifyAllOpen, setNotifyAllOpen] = useState(false)
  const isHistoryPage = location.pathname.endsWith('/history') || location.pathname.endsWith('/messages')
  const selection = normalisePassSelection(selectedPasses)

  if (!template) return null

  return (
    <>
      <div className='flex flex-row justify-end whitespace-nowrap'>
        <ButtonGroup variant="text" aria-label="Notify passes actions">
          <SidebarAction label="Notification history" icon={<HistoryOutlinedIcon />} active={isHistoryPage} disabled={!selectedPass} onClick={() => navigate(`/templates/${template.template_id}/notify-passes/${selectedPass.pass_id}/history`, { state: { pass: selectedPass } })} />
          <SidebarAction label="Notify selected passes" icon={<EmailOutlinedIcon />} disabled={!selection.count} onClick={() => setNotifySelectedOpen(true)} />
          <SidebarAction label="Notify all passes" icon={<EmailOutlinedIcon />} onClick={() => setNotifyAllOpen(true)} />
        </ButtonGroup>
      </div>
      <NotifySelectedDialog open={notifySelectedOpen} setOpen={setNotifySelectedOpen} template={template} selection={selection} />
      <NotifyAllDialog open={notifyAllOpen} setOpen={setNotifyAllOpen} template={template} />
    </>
  )
}

export default NotifyPassesMenu

const normalisePassSelection = selection => Array.isArray(selection)
  ? { type: 'loaded', count: selection.length, mode: 'live', passes: selection }
  : selection ?? { type: 'loaded', count: 0, mode: 'live', passes: [] }
